// Secret key for XOR encryption
const SECRET_KEY = 'kP9!xV7#Q2m@F6r$T1b^Z8p&L3s*W0dHnE4u%Y5j+C7a$R8';
export function encryptData(data: string): string {
  if (!data) {
    throw new Error('Encryption failed - invalid input: data must be a non-empty string');
  }

  try {
    const encryptedBytes: number[] = [];

    for (let i = 0; i < data.length; i++) {
      const keyCharCode = SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
      const dataCharCode = data.charCodeAt(i);
      encryptedBytes.push(dataCharCode ^ keyCharCode);
    }

    const binaryString = String.fromCharCode(...encryptedBytes);
    return btoa(binaryString);

  } catch (error) {
    console.error('Encryption failed for user data:', error);
    throw new Error('Encryption failed - cannot send unencrypted PII data');
  }
}

